import React from "react";
import ConveniosYearPage from "./ConveniosYearPage";
import { convenios2021 } from "../../../../data/Convenios/dataConvenios";

const Convenios2021 = () => <ConveniosYearPage year={2021} data={convenios2021} />;

export default Convenios2021;